import type { AptosWallet } from '@aptos-labs/wallet-standard';
import type { DynamicClient } from '@dynamic-labs-sdk/client';
import {
  WalletProviderPriority,
  getWalletProviderRegistry,
} from '@dynamic-labs-sdk/client/core';

import { createWalletProviderFromAptosStandardWallet } from '../createWalletProviderFromAptosStandardWallet';
import { hasAllRequiredFeatures } from '../hasAllRequiredFeatures';

export const registerAptosStandardWallet = (
  wallet: AptosWallet,
  client: DynamicClient
) => {
  const walletProviderRegistry = getWalletProviderRegistry(client);

  if (hasAllRequiredFeatures(wallet)) {
    const walletProvider = createWalletProviderFromAptosStandardWallet({
      dynamicClient: client,
      walletStandardWallet: wallet,
    });

    walletProviderRegistry.register({
      priority: WalletProviderPriority.WALLET_SELF_ANNOUNCEMENT_STANDARD,
      walletProvider,
    });
  }
};
